<div class="firstDiv"><h5 class="ShippingHeading">SHIPPING POLICY</h5></div>

<div  class="secondDiv">
    <p class="shippingPara">Shipping Policy
        Thank you for shopping with FRRANKY. We’re committed to delivering your order safely and on time. Here’s everything you need to know about our shipping process:<br>
    </p><h5 class="SubHeadings">
    1. Order Processing</h5>
   <p class="para"> Orders are processed within 1–2 business days (excluding weekends and holidays).
    
    
    Once your order is confirmed, you’ll receive a confirmation email with the order details.
    
    
    After dispatch, a tracking link will be shared via email or SMS.</p>
    
    
    <h5 class="SubHeadings">2. Shipping Time</h5>
    <p class="para">Domestic Shipping (India): Delivery within 3–7 business days depending on your location.
    
    
    Note: Delivery time may vary during high-demand seasons or due to courier delays.</p>
    
   <h5 class="SubHeadings">3. Shipping Charges</h5> 
   <p class="para">  Free shipping on all prepaid orders above ₹ 1,999.00
    
    
    Standard shipping rates apply for orders below this amount and for Cash on Delivery (COD), if available.</p>
    
    
    
   <h5 class="SubHeadings">4. Courier Partners</h5> 
   <p class="para"> We partner with trusted delivery services like Delhivery, Bluedart, DTDC, and others to ensure your order reaches you safely.</p>
    
    
   <h5 class="SubHeadings">5. Order Tracking</h5>
   <p class="para">Once your order is shipped, you’ll receive a tracking ID via email or SMS.
    
    
    You can track your order anytime through the link provided.</p>
    
    
    
    <h5 class="SubHeadings">6. Delays & Exceptions</h5>
    <p class="para">  While we do our best to deliver on time, weather, holidays, or logistics issues may cause rare delays.
    
    
    In case of any delay beyond the estimated time, please reach out to our support team.</p>
    
    
    
   <h5 class="SubHeadings">7. Contact Us</h5>
   <p class="para">  If you have questions or issues related to shipping, contact us at:
     📧 [yourbrand@email.com]<br>
     📞 [Customer Support Number] </p>
    </div>
    
